import CXMApiClient from "../CXMApiClient";
import Vue from "vue";

function initialState() {
  return {
    StepModalInfo: {
      showModal: false,
      message: ""
    },
    EndVisitModalInfo: {
      showModal: false,
      data: null
    }
  };
}

const state = initialState();

const getters = {};

const actions = {
  getInShowroomData(context, request) {
    return new Promise((resolve, reject) => {
      let cxmApiClient = new CXMApiClient();
      cxmApiClient
        .ProcessRequest(
          "POST",
          "/api/Activity/summary/in_showroom",
          request.filter,
          request.scope
        )
        .then(resp => {
          if (resp && resp.data) resolve(resp.data);
          else reject(data);
        })
        .catch(resp => {
          reject(resp);
        });
    });
  },
  getAdditionalLeadsCountData(context, request) {
    return new Promise((resolve, reject) => {
      let cxmApiClient = new CXMApiClient();
      cxmApiClient
        .ProcessRequest(
          "POST",
          "/api/CrmLead/showroom_log/additional_lead_count",
          request.filter,
          request.scope
        )
        .then(resp => {
          if (resp && resp.data) resolve(resp.data);
          else reject(data);
        })
        .catch(resp => {
          reject(resp);
        });
    });
  },
  getAdditionalLeadsData(context, request) {
    return new Promise((resolve, reject) => {
      let cxmApiClient = new CXMApiClient();
      cxmApiClient
        .ProcessRequest(
          "POST",
          "/api/CrmLead/showroom_log/additional_lead_detail",
          request.filter,
          request.scope
        )
        .then(resp => {
          if (resp && resp.data) resolve(resp.data);
          else reject(data);
        })
        .catch(resp => {
          reject(resp);
        });
    });
  },
  getShowroomAppointments(context, request) {
    return new Promise((resolve, reject) => {
      let cxmApiClient = new CXMApiClient();
      cxmApiClient
        .ProcessRequest(
          "POST",
          "/api/calendarevent/appointment/counts",
          request.filter,
          request.scope
        )
        .then(resp => {
          if (resp && resp.data) resolve(resp.data);
          else reject(data);
        })
        .catch(resp => {
          reject(resp);
        });
    });
  },
  getShowroomFAndI(context, request) {
    return new Promise((resolve, reject) => {
      let cxmApiClient = new CXMApiClient();
      cxmApiClient
        .ProcessRequest(
          "POST",
          "/api/Activity/summary/delivery_activity",
          request.filter,
          request.scope
        )
        .then(resp => {
          if (resp && resp.data) resolve(resp.data);
          else reject(data);
        })
        .catch(resp => {
          reject(resp);
        });
    });
  },
  getShowroomDelivery(context, request) {
    return new Promise((resolve, reject) => {
      let cxmApiClient = new CXMApiClient();
      cxmApiClient
        .ProcessRequest(
          "POST",
          "/api/Activity/summary/delivery",
          request.filter,
          request.scope
        )
        .then(resp => {
          if (resp && resp.data) resolve(resp.data);
          else reject(data);
        })
        .catch(resp => {
          reject(resp);
        });
    });
  },
  getShowroomDeliveryResults(context, request) {
    return new Promise((resolve, reject) => {
      let cxmApiClient = new CXMApiClient();
      cxmApiClient
        .ProcessRequest(
          "POST",
          "api/touchpoint/activity/" + request.slug + "/results",
          request.filter,
          request.scope
        )
        .then(resp => {
          if (resp && resp.data) resolve(resp.data);
          else reject(data);
        })
        .catch(resp => {
          reject(resp);
        });
    });
  },
  updateStepInfoModal: function(context, data) {
    context.commit("updateStepInfoModal", data);
  },
  updateEndVisitModalInfo: function(context, data) {
    context.commit("updateEndVisitModalInfo", data);
  }
};

const mutations = {
  updateStepInfoModal: function(state, data) {
    state.StepModalInfo = data;
  },
  updateEndVisitModalInfo: function(state, data) {
    state.EndVisitModalInfo = data;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/ShowroomDashboard.js